import React from 'react'
import { getFormValues } from 'redux-form'
import moment from 'moment'
import ConsultaCea from '../../../models/calado/consulta_cea'
import DetalleListadoRepresentantesDialog from '../containers/DetalleListadoRepresentantesDialog'
import { TABLE_CAMIONES_CALADOS, TABLE_CAMIONES_DESCARGADOS } from '../../../config/tables'
import { FORM_LISTADO_REPRESENTANTES } from '../../../config/forms'
import CartaDePorteDescargada from '../../../models/cartaDePorte/carta_de_porte_descargada'
import { obtenerVersionLaridae } from '../../Utils/actions'
import { pdfCustomToolbarGenerator } from '../../../models/tools/generarPdf'
import { COLUMNS_CALADO_REPRESENTANTES, COLUMNS_CALADO_REPRESENTANTES_TO_PRINT } from './TablaListadoRepresentantes'

export function parseData (data) {
  const parsedData = []
  data.data.forEach(entry => {
    const egresoCalado = entry.fechaDeEgresoCalado ? 'Egresado de playa' : 'En playa de calado'
    parsedData.push({ ...entry, fechaCalado: moment(entry.fechaDeCalado).format('DD-MM-YYYY'), detalle: entry, egresoCalado: egresoCalado })
  })
  return parsedData
}

export function updateTablaCamionesCaladosRepresentantes () {
  return (dispatch, getState) => {
    const state = getState()
    const now = moment(Date.now()).format('DD-MM-YYYY')
    const calado = getFormValues(FORM_LISTADO_REPRESENTANTES)(state)

    const fechaD = calado.fechaD ? calado.fechaD : now
    const fechaH = calado.fechaH ? calado.fechaH : now

    const fecha = (fechaD === fechaH) ? `del ${fechaD}` : `entre ${fechaD} y ${fechaH}`

    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLE_CAMIONES_CALADOS
    })

    return ConsultaCea.consultaCamionesCaladosTodos(fechaD, fechaH, state.entregadores.agruparEntregadores)
      .then(callback)
    function callback (d) {
      const data = parseData(d)

      const customToolbar = pdfCustomToolbarGenerator(
        `Listado de cartas de porte caladas ${fecha}`,
        data,
        COLUMNS_CALADO_REPRESENTANTES_TO_PRINT,
        'landscape'
      )

      const textRowCount = `Cantidad de cartas de porte ${fecha} :`
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CALADO_REPRESENTANTES,
          data: data,
          title: ' ',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '499px',
            showRowCount: true,
            textRowCount
          }
        },
        id: TABLE_CAMIONES_CALADOS
      })
    }
  }
}

export function obtenerTotalDetalleCamionesCalados () {
  return (dispatch, getState) => {
    const state = getState()
    const dataCamiones = state.entregadores.dataCamionesCalados
    console.log('dataCamiones', dataCamiones.data)
    dispatch({
      type: 'GENERAR_PDF',
      fileOk: true
    })
  }
};

export function obtenerTotalDetalleCamionesDescargados () {
  return (dispatch, getState) => {
    const state = getState()
    const dataCamiones = state.entregadores.dataCamionesDescargados
    console.log('dataCamiones', dataCamiones.data)
    dispatch({
      type: 'GENERAR_PDF',
      fileOk: true
    })
  }
};

export function actualizarVersion () {
  return (dispatch, getState) => {
    dispatch(obtenerVersionLaridae())
  }
}

export function updateTablaTotalCamionesCalados (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id: TABLE_CAMIONES_CALADOS
    })
  }
}

export function updateTablaTotalCamionesDescargados (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id: TABLE_CAMIONES_DESCARGADOS
    })
  }
}

export function saveDetallePdf () {
  return (dispatch, getState) => {
    dispatch({
      type: 'GENERAR_DETALLE_PDF',
      fileDetallePdfOk: false
    })
    dispatch({
      type: 'DETALLE_MERCADERIA',
      data: []
    })
  }
}

export function saveAllPdf () {
  return (dispatch, getState) => {
    dispatch({
      type: 'GENERAR_PDF',
      fileOk: false
    })
  }
}

export function openDialogDetalles (detalle) {
  return (dispatch, getState) => {
    dispatch({
      type: 'ACTUALIZAR_DETALLES',
      detalle: detalle
    })
    const confirmCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'DETALLE_CAMIONES_CALADOS'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'DETALLE_CAMIONES_CALADOS',
      title: 'Detalles de Camiones Calados',
      maxWidth: 'xl',
      showPrint: true,
      content: <DetalleListadoRepresentantesDialog />,
      confirmCallback: confirmCallback
    })
  }
}

// export function openDialogDetallesDescargas (detalle) {
//   return (dispatch, getState) => {
//     dispatch({
//       type: 'ACTUALIZAR_DETALLES',
//       detalle: detalle
//     })
//     const confirmCallback = () => {
//       dispatch({
//         type: 'CLOSE_DIALOG',
//         id: 'DETALLE_CAMIONES_DESCARGADOS'
//       })
//     }
//     dispatch({
//       type: 'OPEN_DIALOG',
//       id: 'DETALLE_CAMIONES_DESCARGADOS',
//       title: 'Detalles de Camiones Descargados',
//       maxWidth: 'xl',
//       showPrint: true,
//       content: <DetalleListadoDescargasDialog />,
//       confirmCallback: confirmCallback
//     })
//   }
// }

export function generarDetallesPdf () {
  return (dispatch, getState) => {
    dispatch(obtenerTotalDetalleCamionesCalados())
  }
}

export function generarDetallesDescargasPdf () {
  return (dispatch, getState) => {
    dispatch(obtenerTotalDetalleCamionesDescargados())
  }
}

export function actualizarDetallesSecada (detalle) {
  return (dispatch, getState) => {
    dispatch({
      type: 'ACTUALIZAR_DETALLES_SECADA',
      detalle: detalle
    })
  }
}

export function updateRechazados (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_RECHAZADOS',
      newState
    })
  }
}

export function updateAgrupados (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_AGRUPADOS',
      newState
    })
  }
}

export function obtenerDetalleMercaderia (cartaDePorteAutomotor, callback) {
  return (dispatch, getState) => {
    return CartaDePorteDescargada.getConsultaCeaTicketDescarga(cartaDePorteAutomotor)
      .then((data) => {
        dispatch({
          type: 'DETALLE_MERCADERIA',
          data: data
        })
        return CartaDePorteDescargada.getInterdictoDeCartaDePorteAutomotor(cartaDePorteAutomotor)
          .then((data) => {
            if (data !== undefined) {
              const hoy = new Date()
              const desde = new Date(data.inicioDeInterdicto)
              const hasta = new Date(data.finDeInterdicto)
              if (desde.valueOf() >= hoy.valueOf() && hasta.valueOf() <= hoy.valueOf()) {
                dispatch({
                  type: 'INTERDICTO_CARTA_DE_PORTE',
                  data: data.acta
                })
              }
            }
          })
      },
      callback && callback())
  }
}

export function descargarDetallesPDF () {
  return (dispatch, getState) => {
    dispatch({
      type: 'GENERAR_DETALLE_PDF',
      fileDetallePdfOk: true
    })
    dispatch({
      type: 'RELEASE_INTERDICTO_CARTA_DE_PORTE'
    })
  }
}

export function actualizarDetalles (cartaDePorteAutomotor) {
  return (dispatch, getState) => {
    dispatch({
      type: 'ACTUALIZAR_DETALLES',
      detalle: cartaDePorteAutomotor
    })
  }
}
